type TabsProps = {
  activeTab: number;
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
  index: number;
  text: string;
};

export const Tabs = ({ activeTab, setActiveTab, text, index }: TabsProps) => {
  return (
    <button
      onClick={() => setActiveTab(index)}
      className={`rounded-none bg-transparent px-3 py-2 text-sm font-bold ${activeTab === index ? "border-brand600 text-brand600 border-0 border-b-2" : "text-gray-700"} hover:text-brand700 outline-hidden focus:outline-hidden`}
    >
      {text}
    </button>
  );
};
